/** @format */
import { Trans, useTranslation } from 'next-i18next';
import React, { FunctionComponent, useContext } from 'react';

import { MarketContext } from '@toucan/client/global/market';

import { ProductDetailsListItem } from '../product-details-list-item';
import {
    getAttributeIcon,
    getAttributePrefix,
    getFormattedAttributeContent,
} from './helpers';
import { ProductAttributeListItemProps } from './types';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const DEFAULT_TEST_ID = 'product-attribute-list-item';

export const ProductAttributeListItem: FunctionComponent<
    ProductAttributeListItemProps
> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    attribute,
    ...otherProps
}) => {
    const { t } = useTranslation();
    const { activeMarket } = useContext(MarketContext);

    const Icon = getAttributeIcon(attribute.name);

    return (
        <ProductDetailsListItem
            {...otherProps}
            data-testid={dataTestId}
            icon={<Icon />}
            title={
                <Trans
                    components={{
                        'bold-text': <strong key={0}>$1</strong>,
                    }}
                >
                    {t('{{prefix}}: <bold-text>{{content}}</bold-text>', {
                        prefix: getAttributePrefix(t, attribute.name),
                        content: attribute.content
                            ? getFormattedAttributeContent(
                                  activeMarket,
                                  attribute
                              )
                            : t('Not available'),
                    })}
                </Trans>
            }
        />
    );
};
